import { DBConnectorService } from './../service/test.service';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {
  tabSelected = 'rules';
  Admin = false;
  RoleId = '';
  onSelect(tab: string) {
    this.tabSelected = tab;
  }


  constructor(private dbconnectorservice: DBConnectorService) {
    this.Admin = this.dbconnectorservice.Admin;
    this.RoleId = this.dbconnectorservice.RoleID;
  }

  ngOnInit() {
  }

}
